/** Estilos de tooltip do Recharts alinhados ao design system (claro/escuro). */
export const chartTooltipProps = {
  contentStyle: {
    background: 'hsl(var(--popover))',
    border: '1px solid hsl(var(--border))',
    borderRadius: 12,
    fontSize: 12,
    color: 'hsl(var(--popover-foreground))',
  },
  itemStyle: {
    color: 'hsl(var(--popover-foreground))',
  },
  labelStyle: {
    color: 'hsl(var(--popover-foreground))',
  },
} as const;

/**
 * Destaque do hover (`cursor` do Tooltip). Sem ele o Recharts pinta #ccc fixo:
 * nas barras vira um bloco quase branco no tema escuro.
 */
export const chartBarCursor = { fill: 'hsl(var(--foreground) / 0.08)' } as const;

/** Linha vertical do hover em gráfico de área/linha (mesmo motivo). */
export const chartLineCursor = { stroke: 'hsl(var(--muted-foreground) / 0.5)', strokeDasharray: '4 4' } as const;

export const chartLegendStyle = {
  fontSize: 12,
  color: 'hsl(var(--foreground))',
} as const;

export const chartAxisTick = {
  fontSize: 12,
  fill: 'hsl(var(--muted-foreground))',
} as const;
